import { validateUserNameApi } from "../contants";

export const validateUserName = (userName: string) => {
	return {
		url: `${validateUserNameApi}/${userName}`,
        method: 'GET',
	};
};
